/* Topbar announcement rotator.
 *
 * Accessibility contract (WCAG 2.2.2): rotation runs exactly ONE full cycle
 * (each message once, back to the first) and then stops, so the bar ceases
 * to auto-update without needing a visible pause control. Hover and focus
 * pause it while it runs.
 *
 * Nothing may move on load: message 1 ships .is-current in the markup and
 * transitions stay disabled until .ready lands after the 5s opening dwell —
 * delaying only the timer is not enough, the first swap would animate from
 * an unstyled start.
 */
(() => {
  if (customElements.get('topbar-rotator')) return;

  class TopbarRotator extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.promo__msg'));
      if (this.items.length < 2) return;

      this.idx = 0;
      this.swapsLeft = this.items.length; // one full cycle: 1→2→3→1, then stop
      this.paused = false;

      this.addEventListener('mouseenter', () => (this.paused = true));
      this.addEventListener('mouseleave', () => (this.paused = false));
      this.addEventListener('focusin', () => (this.paused = true));
      this.addEventListener('focusout', () => (this.paused = false));

      // Theme editor: selecting an announcement block shows that message.
      document.addEventListener('shopify:block:select', (e) => {
        const hit = this.items.findIndex((m) => m.contains(e.target) || m === e.target);
        if (hit < 0) return;
        this.stop();
        this.show(hit);
      });

      this.dwell = setTimeout(() => {
        this.classList.add('ready');
        this.timer = setInterval(() => this.tick(), 5000);
      }, 5000);
    }

    disconnectedCallback() {
      clearTimeout(this.dwell);
      this.stop();
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    show(nextIdx) {
      const prev = this.items[this.idx];
      const next = this.items[nextIdx];
      if (prev === next) return;
      prev.classList.remove('is-current');
      prev.classList.add('is-leaving');
      prev.setAttribute('aria-hidden', 'true');
      next.classList.remove('is-leaving');
      next.classList.add('is-current');
      next.removeAttribute('aria-hidden');
      setTimeout(() => prev.classList.remove('is-leaving'), 500);
      this.idx = nextIdx;
    }

    tick() {
      if (this.paused || !this.timer) return;
      // Hidden (e.g. the bar's desktop column at mobile widths): don't
      // burn the one allowed cycle where nobody can see it.
      if (!this.offsetParent) return;
      this.show((this.idx + 1) % this.items.length);
      this.swapsLeft -= 1;
      if (this.swapsLeft <= 0) this.stop();
    }
  }

  customElements.define('topbar-rotator', TopbarRotator);
})();
